import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import QuestionnaireRoute from './components/QuestionnaireRoute';
import Login from './pages/Login';
import RegisterStudent from './pages/RegisterStudent';
import RegisterTeacher from './pages/RegisterTeacher';
import TeacherQuestionnaire from './pages/TeacherQuestionnaire';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Classroom from './pages/Classroom';
import Settings from './pages/Settings';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import TeachersList from './pages/TeachersList';
import TeacherProfile from './pages/TeacherProfile';
import ApproveTeacher from './pages/ApproveTeacher';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register/student" element={<RegisterStudent />} />
          <Route path="/register/teacher" element={<RegisterTeacher />} />
          <Route
            path="/teacher-questionnaire"
            element={
              <QuestionnaireRoute>
                <TeacherQuestionnaire />
              </QuestionnaireRoute>
            }
          />
          <Route
            path="/verify-email"
            element={
              <PrivateRoute>
                <VerifyEmail />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/home"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/schedule"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/lessons"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/students"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/finance"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/history"
            element={<Navigate to="/dashboard/lessons" replace />}
          />
          <Route
            path="/dashboard/video-test"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/materials"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/materials/:submissionId"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/statistics"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/classroom/:teacherId"
            element={
              <PrivateRoute>
                <Classroom />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/teachers"
            element={
              <PrivateRoute>
                <TeachersList />
              </PrivateRoute>
            }
          />
          <Route
            path="/teachers/:teacherId"
            element={
              <PrivateRoute>
                <TeacherProfile />
              </PrivateRoute>
            }
          />
          <Route path="/approve-teacher/:token" element={<ApproveTeacher />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

